import React, { useRef, useEffect, useState } from 'react'
import styles from './PackageItem.module.css'

import Image from '../../Stage/components/Image/Image';

const PackageItem = ({
    progress,
    maxProgress,
    width,
    title,
    imageUrl,
    onClick,
}) => {
    const ref = useRef(null)
    const [progressWidth, setProgressWidth] = useState(0)

    useEffect(() => {
        if (ref.current) {
            setProgressWidth((progress / maxProgress) * ref.current.offsetWidth)
        }
    }, [width, progress, maxProgress])


    return (
        <div
            className={styles.container}
            onClick={onClick}>
            <Image imagePath={imageUrl} className={styles.img} />
            <div className={styles.infoContainer}>
                <div className={styles.upperInfoContainer}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.progressText}>{(progress === undefined ? 0 : progress) + '/' + maxProgress}</span>
                </div>
                <div className={styles.containerProgress} ref={ref}>
                    <div className={styles.innerProgress} style={{ width: progressWidth + 'px', minWidth: progressWidth ? '24px' : '' }} />
                </div>
            </div>
        </div>
    )
}

export default PackageItem
